import $script from 'scriptjs'
import utilsService from '@/services/amio/utils.service'

const SCRIPT_URL = 'https://chat.cdn-plain.com/index.js'
const APP_ID = 'liveChatApp_01M2JHY5HXQEK8YHZX87PN4BCA'

class PlainChatService {
  constructor() {
    this._initialized = false
    this._loading = null
  }

  // The widget session has to exist before the first click, otherwise a reply that
  // arrives while the chat is closed never reaches the browser notification path.
  prepare() {
    return this._customerDetails().then(customerDetails => this._ensureInitialized(customerDetails))
  }

  open() {
    return this.prepare().then(customerDetails => {
      if (customerDetails && window.Plain && typeof window.Plain.setCustomerDetails === 'function') {
        window.Plain.setCustomerDetails(customerDetails)
      }
      if (window.Plain && typeof window.Plain.open === 'function') {
        window.Plain.open()
      }
    })
  }

  _ensureInitialized(customerDetails) {
    if (this._initialized) return Promise.resolve(customerDetails)
    if (!this._loading) {
      this._loading = new Promise((resolve, reject) => {
        $script(SCRIPT_URL, () => {
          try {
            const initConfig = {
              appId: APP_ID,
              hideLauncher: true,
              entryPoint: { type: 'default' }
            }
            if (customerDetails) initConfig.customerDetails = customerDetails
            window.Plain.init(initConfig)
            this._initialized = true
            resolve()
          } catch (err) {
            reject(err)
          }
        })
      }).catch(err => {
        this._loading = null
        throw err
      })
    }

    return this._loading.then(() => customerDetails)
  }

  async _customerDetails() {
    try {
      const identity = await utilsService.getPlainChatIdentity()
      if (identity?.email && identity?.email_hash) {
        return {
          email: identity.email,
          emailHash: identity.email_hash
        }
      }
    } catch (err) {
      return null
    }
    return null
  }
}

export default new PlainChatService()
